import { render, staticRenderFns } from "./LegalDocumentMessagesEscalated.vue?vue&type=template&id=f6815056&scoped=true&"
import script from "./LegalDocumentMessagesEscalated.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentMessagesEscalated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6815056",
  null
  
)

export default component.exports